module.exports = __webpack_public_path__ + "media/images/emblems/Hettlingen-blazon-fb5822c1db0a331aaf3c9abbbe48cb6e.svg";